import React, { useEffect } from "react";
import { GOOGLE_AUTH_URL, ACCESS_TOKEN } from "../../constants";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { getCurrentUser, logoutUser } from "../../util/APIUtils";

const Login = ({ authenticated }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const error = searchParams.get('error');
        const message = searchParams.get('message');

        if (error) {
            toast.error(message || 'Authentication failed', {
                autoClose: false,
                closeOnClick: false,
                toastId: 'auth-error'
            });
            window.location.replace(GOOGLE_AUTH_URL);
            return;
        }

        if (location?.state?.error) {
            toast.error(location.state.error, { autoClose: 5000 });
        }
    }, [location, searchParams]);

    useEffect(() => {
        const checkAuthentication = async () => {
            const token = localStorage.getItem(ACCESS_TOKEN);

            if (!token) {
                console.log("No access token, redirecting to Google login...");
                window.location.replace(GOOGLE_AUTH_URL);
                return;
            }

            try {
                await getCurrentUser(); // Will throw if invalid
                navigate("/", { replace: true });
            } catch (error) {
                console.error("Error fetching current user:", error);
                logoutUser();
            }
        };

        checkAuthentication();
    }, [authenticated, navigate, searchParams]);

    return null;
};

export default Login;
